export default __webpack_public_path__ + "static/media/mbb.531b28b7.svg";